enum LocalStorageKeyEnum {
  AccessToken = 'accessToken',
}

export default LocalStorageKeyEnum;
